<button
  class="pagination-button"
  [ngClass]="{ 'pagination-button--selected': selected }"
  (click)="onClick()"
>
  {{ page }}
</button>
